import { render, staticRenderFns } from "./createQuotation.vue?vue&type=template&id=6f6d6a42&scoped=true"
import script from "./createQuotation.vue?vue&type=script&lang=ts"
export * from "./createQuotation.vue?vue&type=script&lang=ts"
import style0 from "./createQuotation.vue?vue&type=style&index=0&id=6f6d6a42&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d6a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6d6a42')) {
      api.createRecord('6f6d6a42', component.options)
    } else {
      api.reload('6f6d6a42', component.options)
    }
    module.hot.accept("./createQuotation.vue?vue&type=template&id=6f6d6a42&scoped=true", function () {
      api.rerender('6f6d6a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddCart/createQuotation.vue"
export default component.exports